import { FC } from "react";
import styles from "./Header.module.css";
import { UserDb } from "../../models/user.db";
interface PropTypes {
  user: UserDb | null;
  logoUrl: string;
}

const Header: FC<PropTypes> = ({ user, logoUrl: photoURL }) => {
  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <img src={photoURL} width={102} height={31} alt="logo" />
      </div>
      <div className={styles.slogan}>
        Indyx makes your closet your favorite place to shop. Download the app to
        start styling {user?.firstName ?? ""}'s closet.
      </div>
    </div>
  );
};
export default Header;
